import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { installChunkErrorRecovery } from "@/lib/chunkRecovery";

// Auto-heal stale bundles after a redeploy: catches ChunkLoadError from
// route splits and does one fresh reload so users don't see mysterious
// "Script error." toasts. Safe to call once at bootstrap.
installChunkErrorRecovery();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
